import React from 'react';
import { Col } from 'react-bootstrap';
import './Footer.css'; // Import your CSS file

const Footer = () => {
  return (
    <Col className="footer">
      <span className='footer-text'>Powered by MYT Softdev Solutions</span>
    </Col>
  );
};

export default Footer;
